import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FileInfo, FileRestrictions } from '@progress/kendo-angular-upload';
import { AttachmentBus } from '../../models/AttachmentBus';
import { GlobalsService } from '../../services/globals.service';
import { CommonFunctions } from '../../static/common-functions';
import { Subscription } from 'rxjs';
import { BaseMessageInfo } from '../../models/BaseMessageInfo';
import { InvoiceService } from '../../services/invoice.service';

import { MessageInfo } from '../../models/MessageInfo';
import { MessageInfoType } from '../../enums/MessageInfoType';
import { CmProAuthService } from '@app/core/services';
import { AppClaims } from '../../models/AppClaims';
import { UsersBus } from '../../models/UsersBus.model';
import { CommonValues } from '../../static/CommonValues';
import { InventoryService } from '../../services/inventory.service';

@Component({
    selector: 'cp-custom-uploads',
    templateUrl: './custom-uploads.component.html',
    styleUrls: ['./custom-uploads.component.scss']
})
export class CustomUploadsComponent implements OnInit, OnDestroy {
    @Input() active: boolean = false;
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();
    subs_importNotes: Subscription;
    subs_importInvoiceStatus: Subscription;
    popupClass: string = 'custom-dl';
    fileDataLoadingCollection: boolean = false;
    fileDataLoadingInvoice: boolean = false;
    showSuccessCollection: boolean = false;
    showFailCollection: boolean = false;
    showSuccessInvoice: boolean = false;
    showFailInvoice: boolean = false;
    invalidIds: MessageInfo[] = [];
    showSuccessWarehouseThreshold: boolean = false;
    showFailWarehouseThreshold: boolean = false;
    fileDataLoadingWarehouseThreshold: boolean = false;
    subs_importWarehouseThreshold: Subscription;

    showSuccessBranchThreshold: boolean = false;
    showFailBranchThreshold: boolean = false;
    fileDataLoadingBranchThreshold: boolean = false;
    subs_importBranchThreshold: Subscription;

    showSuccessPart: boolean = false;
    showFailPart: boolean = false;
    fileDataLoadingPart: boolean = false;
    subs_importPart: Subscription;   


    msgSuccess: string = "";
    msgFail: string = "";
    rights: AppClaims = new AppClaims();
    constructor(public globals: GlobalsService, private svc_data: InvoiceService, private authService: CmProAuthService, private inventoryService: InventoryService) {

    }

    ngOnInit() {
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
            }
        });
    }

    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
    }

    hasUploadRights() {
        return this.rights?.CollectionBulkUpload || this.rights?.BulkUploadInventory;
    }

    hide() {
        this.active = false;
    }
    close() {
        this.hide();
        this.closed.emit(true);
    }

    public show() {
        this.active = true;
    }
    uploadRestrictions: FileRestrictions = {
        allowedExtensions: ['.xlsx', '.xls']
    };

    mainLoadingOn(disableAll: boolean = false, type: string) {
        if (type == 'collection') {
            this.fileDataLoadingCollection = true;
        } else if (type == 'invoice') {
            this.fileDataLoadingInvoice = true;
        } else if (type == 'warehousethreshold') {
            this.fileDataLoadingWarehouseThreshold = true;
        } else if (type == 'branchthreshold') {
            this.fileDataLoadingBranchThreshold = true;
        } else if (type == 'part') {
            this.fileDataLoadingPart = true;
        }
        
        
    }
    mainLoadingOff(enableAll: boolean = false) {
        this.fileDataLoadingInvoice = false;
        this.fileDataLoadingCollection = false;
        this.fileDataLoadingWarehouseThreshold = false;
        this.fileDataLoadingBranchThreshold = false;
        this.fileDataLoadingPart = false;
    }
    importBid(files: Array<FileInfo>) {
        let attachment: AttachmentBus = new AttachmentBus();
        if (files.length > 0 && CommonFunctions.hasValue(files[0].rawFile)) {

            attachment.attachmentName = files[0].name;
            attachment.attachmentType = files[0].extension;
            if (attachment.attachmentType.indexOf('.xlsx') < 0
                && attachment.attachmentType.indexOf('.xls') < 0) {
                this.globals.notifyError("The Bid File is not the correct extension.", true);
            }
            else {
                this.mainLoadingOn(true, 'collection');
                CommonFunctions.unsubscribe(this.subs_importNotes);
                this.subs_importNotes = this.svc_data.importCollectionNotes(files, attachment).subscribe(
                    {
                        next:
                            (info: BaseMessageInfo) => {
                                this.mainLoadingOff(true);
                                this.showFailCollection = false;
                                this.showSuccessCollection = false;
                                this.msgFail = "";
                                this.msgSuccess = "";
                                if (!info.saveError) {
                                    if (info.message) {
                                        this.showSuccessCollection = true;
                                        this.msgSuccess = info.message;
                                    }
                                    else {
                                        this.showSuccessCollection = true;
                                        this.msgSuccess = info.message;
                                    }
                                }
                                else {
                                    this.showFailCollection = true;
                                    this.msgFail = info.message;
                                    this.invalidIds = info.messages.filter(s => s.messageType === MessageInfoType.warning);
                                }
                            },
                        error: e => {
                            console.error(e);
                            this.mainLoadingOff(true);
                            this.globals.notifyError(`Unable to upload Bif File. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                        }
                    });
            }
        }
    }

    importInvoiceStatus(files: Array<FileInfo>) {
        let attachment: AttachmentBus = new AttachmentBus();
        if (files.length > 0 && CommonFunctions.hasValue(files[0].rawFile)) {

            attachment.attachmentName = files[0].name;
            attachment.attachmentType = files[0].extension;
            if (attachment.attachmentType.indexOf('.xlsx') < 0
                && attachment.attachmentType.indexOf('.xls') < 0) {
                this.globals.notifyError("The Invoice File is not the correct extension.", true);
            }
            else {
                this.mainLoadingOn(true, 'invoice');
                CommonFunctions.unsubscribe(this.subs_importInvoiceStatus);
                this.subs_importInvoiceStatus = this.svc_data.importInvoiceStatusChange(files, attachment).subscribe(
                    {
                        next: (info: BaseMessageInfo) => {
                            this.mainLoadingOff(true);
                            this.showFailInvoice = false;
                            this.showSuccessInvoice = false;
                            this.msgFail = "";
                            this.msgSuccess = "";
                            if (!info.saveError)
                            {
                                if (info.message) {
                                    this.showSuccessInvoice = true;
                                    this.msgSuccess = info.message;
                                }
                                else {
                                    this.showSuccessInvoice = true;
                                    this.msgSuccess = info.message;
                                }
                            }
                            else {
                                this.showFailInvoice = true;
                                this.msgFail = info.message;
                                this.invalidIds = info.messages.filter(s => s.messageType === MessageInfoType.warning);

                            }
                        },
                        error: (err) => {
                            console.error(err);
                            this.mainLoadingOff(true);
                            this.globals.notifyError(`Unable to upload Invoice Status File. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                        }
                    }
                );
        }
    }
}
    importWarehouseThreshold(files: Array<FileInfo>) {
        let attachment: AttachmentBus = new AttachmentBus();
        if (files.length > 0 && CommonFunctions.hasValue(files[0].rawFile)) {

            attachment.attachmentName = files[0].name;
            attachment.attachmentType = files[0].extension;
            if (attachment.attachmentType.indexOf('.xlsx') < 0
                && attachment.attachmentType.indexOf('.xls') < 0) {
                this.globals.notifyError("The Warehouse Threshold is not the correct extension.", true);
            }
            else {
                this.mainLoadingOn(true, 'warehousethreshold');
                CommonFunctions.unsubscribe(this.subs_importWarehouseThreshold);
                this.subs_importWarehouseThreshold = this.inventoryService.importThreshold(files, attachment).subscribe(
                    {
                        next: (info: BaseMessageInfo) => {
                            this.mainLoadingOff(true);
                            this.showFailWarehouseThreshold = false;
                            this.showSuccessWarehouseThreshold = false;
                            this.msgFail = "";
                            this.msgSuccess = "";
                            if (!info.saveError) {
                                if (info.message) {
                                    this.showSuccessWarehouseThreshold = true;
                                    this.msgSuccess = info.message;
                                }
                                else {
                                    this.showSuccessWarehouseThreshold = true;
                                    this.msgSuccess = info.message;
                                }
                            }
                            else {
                                this.showFailWarehouseThreshold = true;
                                this.msgFail = info.message;
                                this.invalidIds = info.messages.filter(s => s.messageType === MessageInfoType.error);

                            }
                        },
                        error: (err) => {
                            console.error(err);
                            this.mainLoadingOff(true);
                            this.globals.notifyError(`Unable to upload Warehouse Threshold File. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                        }
                    }
                );
            }
        }
    }
    importBranchThreshold(files: Array<FileInfo>) {
        let attachment: AttachmentBus = new AttachmentBus();
        if (files.length > 0 && CommonFunctions.hasValue(files[0].rawFile)) {

            attachment.attachmentName = files[0].name;
            attachment.attachmentType = files[0].extension;
            if (attachment.attachmentType.indexOf('.xlsx') < 0
                && attachment.attachmentType.indexOf('.xls') < 0) {
                this.globals.notifyError("The Branch Threshold is not the correct extension.", true);
            }
            else {
                this.mainLoadingOn(true, 'branchthreshold');
                CommonFunctions.unsubscribe(this.subs_importBranchThreshold);
                this.subs_importBranchThreshold = this.inventoryService.ImportBranchThreshold(files, attachment).subscribe(
                    {
                        next: (info: BaseMessageInfo) => {
                            this.mainLoadingOff(true);
                            this.showFailBranchThreshold = false;
                            this.showSuccessBranchThreshold = false;
                            this.msgFail = "";
                            this.msgSuccess = "";
                            if (!info.saveError) {
                                if (info.message) {
                                    this.showSuccessBranchThreshold = true;
                                    this.msgSuccess = info.message;
                                }
                                else {
                                    this.showSuccessBranchThreshold = true;
                                    this.msgSuccess = info.message;
                                }
                            }
                            else {
                                this.showFailBranchThreshold = true;
                                this.msgFail = info.message;
                                this.invalidIds = info.messages.filter(s => s.messageType === MessageInfoType.error);

                            }
                        },
                        error: (err) => {
                            console.error(err);
                            this.mainLoadingOff(true);
                            this.globals.notifyError(`Unable to upload Branch Threshold File. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                        }
                    }
                );
            }
        }
    }
    importPart(files: Array<FileInfo>) {
        let attachment: AttachmentBus = new AttachmentBus();
        if (files.length > 0 && CommonFunctions.hasValue(files[0].rawFile)) {

            attachment.attachmentName = files[0].name;
            attachment.attachmentType = files[0].extension;
            if (attachment.attachmentType.indexOf('.xlsx') < 0
                && attachment.attachmentType.indexOf('.xls') < 0) {
                this.globals.notifyError("The Part import is not the correct extension.", true);
            }
            else {
                this.mainLoadingOn(true, 'part');
                CommonFunctions.unsubscribe(this.subs_importPart);
                this.subs_importPart = this.inventoryService.importPart(files, attachment).subscribe(
                    {
                        next: (info: BaseMessageInfo) => {
                            this.mainLoadingOff(true);
                            this.showFailPart = false;
                            this.showSuccessPart = false;
                            this.msgFail = "";
                            this.msgSuccess = "";
                            if (!info.saveError) {
                                if (info.message) {
                                    this.showSuccessPart = true;
                                    this.msgSuccess = info.message;
                                }
                                else {
                                    this.showSuccessPart = true;
                                    this.msgSuccess = info.message;
                                }
                            }
                            else {
                                this.showFailPart = true;
                                this.msgFail = info.message;
                                this.invalidIds = info.messages.filter(s => s.messageType === MessageInfoType.error);

                            }
                        },
                        error: (err) => {
                            console.error(err);
                            this.mainLoadingOff(true);
                            this.globals.notifyError(`Unable to upload Part File. ${CommonValues.ErrorMessages_BaseErrorSuffix}`);
                        }
                    }
                );
            }
        }
    }

}
